import { render, staticRenderFns } from "./STblSort.vue?vue&type=template&id=8e668286"
import script from "./STblSort.vue?vue&type=script&lang=js"
export * from "./STblSort.vue?vue&type=script&lang=js"
import style0 from "./STblSort.vue?vue&type=style&index=0&id=8e668286&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports